if (typeof process === 'undefined' || !process.nextTick) {
	// Create a global process object if it doesn't exist
	if (!window.process) {
		// @ts-ignore
		window.process = { env: {} };
	}

	// Define nextTick using the best available microtask mechanism
	/*if (typeof queueMicrotask === 'function') {
		window.process.nextTick = queueMicrotask;
	} else */if (typeof MutationObserver === 'function') {
		const observer = new MutationObserver(runCallbacks);
		const div = document.createElement('div');
		observer.observe(div, { attributes: true });
		let callbacks:{callback: (...args: unknown[]) => void, args: unknown[]}[] = [];

		function runCallbacks() {
			const list = callbacks;
			callbacks = [];
			list.forEach(({callback, args}) => callback(...(args || [])));
		}

		process.nextTick = (callback: (...args: unknown[]) => void, ...args) => {
			callbacks.push({callback, args});
			div.setAttribute('data-tick', Date.now().toString());
		};
	} else {
		// Fallback to setTimeout
		process.nextTick = (callback, ...args) => {
			setTimeout(() => callback(...(args || [])), 0);
		};
	}
}